var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIctIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7.16227V10.3902C14 13.484 11.5329 16 8.49974 16C5.46689 16 3 13.4837 3 10.3902V8.45145C3 8.0673 3.30506 7.75557 3.68176 7.75557H5.18293V10.0571C5.18293 10.3438 5.41084 10.575 5.69169 10.575C5.97253 10.575 6.20048 10.3438 6.20048 10.0571V2.04582C6.20048 2.04482 6.20048 2.04382 6.20048 2.04279C6.19873 1.76545 6.30597 1.50669 6.49705 1.30987C6.69123 1.10989 6.94999 1 7.22581 1C7.79163 1 8.25097 1.4687 8.25097 2.04582V5.94847C8.25097 6.23518 8.47888 6.46639 8.75972 6.46639H13.3179C13.6939 6.46639 14 6.7788 14 7.16227Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIctIcon);
export default __webpack_public_path__ + "static/media/ictIcon.5f7d8ab0841a64cdb2acaf9bb377f0dc.svg";
export { ForwardRef as ReactComponent };